// Phase 15 — Belgian-law interest engine: DISPLAY HELPERS ONLY.
//
// C.2 — the computation half (computeAmount / computeAll / rate-period
// derivation) moved server-side, VERBATIM, to server/src/lib/interestEngine.js
// behind POST /api/interest/compute (recording-proven bit-exact:
// recordings/c2-interest/). The browser sends the calculator state and
// displays what it's handed — it computes no interest. What remains here is
// the Belgian display formatting the views and the memo exporter share.

// --- Formatting helpers (Belgian convention) ------------------------------

const _fmtCache = new Map();
function _fmt(min: any, max: any) {
  const key = `${min}|${max}`;
  if (!_fmtCache.has(key)) {
    _fmtCache.set(
      key,
      new Intl.NumberFormat("fr-BE", {
        minimumFractionDigits: min,
        maximumFractionDigits: max,
      }),
    );
  }
  return _fmtCache.get(key);
}

function fmtBE(n: any, digits = 2) {
  if (n == null || !Number.isFinite(Number(n))) return "—";
  return _fmt(digits, digits).format(Number(n));
}

function fmtBEPercent(rate: any, digits = 2) {
  if (rate == null || !Number.isFinite(Number(rate))) return "—";
  return _fmt(digits, digits).format(Number(rate)) + " %";
}

function fmtBEDate(iso: any) {
  if (!iso) return "—";
  const d = typeof iso === "string" ? new Date(iso) : iso;
  if (Number.isNaN(d.getTime())) return "—";
  const dd = String(d.getUTCDate()).padStart(2, "0");
  const mm = String(d.getUTCMonth() + 1).padStart(2, "0");
  const yy = d.getUTCFullYear();
  return `${dd}/${mm}/${yy}`;
}

export { fmtBE, fmtBEPercent, fmtBEDate };
